var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApproved = function SvgApproved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/16*16/informative/approved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45378 14.6663C12.1357 14.6663 15.1204 11.6816 15.1204 7.99967C15.1204 4.31778 12.1357 1.33301 8.45378 1.33301C4.77188 1.33301 1.78711 4.31778 1.78711 7.99967C1.78711 11.6816 4.77188 14.6663 8.45378 14.6663ZM11.5151 6.30667C11.6847 6.08869 11.6454 5.77456 11.4274 5.60502C11.2094 5.43549 10.8953 5.47475 10.7258 5.69273L8.05444 9.1273C7.99504 9.20367 7.8833 9.21358 7.81138 9.14886L6.1216 7.62805C5.91634 7.44332 5.6002 7.45996 5.41547 7.66522C5.23074 7.87047 5.24738 8.18661 5.45263 8.37134L7.14242 9.89215C7.64584 10.3452 8.42798 10.2759 8.84379 9.74124L11.5151 6.30667Z",
    fill: "#389E0D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "approved.259f61e91dbdceb1e1c9d729a7321d0e.svg";